var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.73912V3.68344C0.0724792 2.73261 0.751333 2.08118 1.61396 2.06949H7.66965C8.47296 2.08295 9.22125 2.37357 9.87719 2.76976L19.3675 13.1938C19.9398 13.9286 19.9691 14.843 19.3675 15.4614L12.3515 22.4508C11.6425 23.0624 10.649 23.1178 10.0839 22.4508L1.14713 12.5002C0.518917 11.7227 0.0093125 10.6993 0 9.73912ZM3.06121 7.33819C3.73142 7.95611 4.69333 7.89894 5.26873 7.33819C5.88385 6.67365 5.83248 5.70171 5.26873 5.13067C4.60331 4.52494 3.63427 4.57301 3.06121 5.13067C2.4529 5.84113 2.47575 6.72871 3.06121 7.33819ZM10.5508 2.09616H12.8717C13.8447 2.15616 14.9961 2.53959 15.6195 3.24328L24.5562 13.2205C25.1601 13.9178 25.1356 14.9193 24.5562 15.5147L17.5669 22.5041C16.5982 23.0531 15.7105 23.0149 15.1126 22.3173L21.9686 15.4613C22.5859 14.7782 22.52 13.7931 21.9686 13.1937L13.9712 4.24557C13.0246 3.06405 10.9865 2.14949 10.5508 2.09616Z",
    fill: "#38AEC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceOrder);
export default __webpack_public_path__ + "static/media/place_order.cf3b158dc188fc1c58bebba7df58aea6.svg";
export { ForwardRef as ReactComponent };